<template>
  <nav>
    <Toolbar v-if="user" :drawer.sync="drawer" />

    <v-navigation-drawer v-if="user" v-model="drawer" app>
      <v-layout>
        <img src="Xerpa_logo.svg" alt="Xerpa" class="ml-2 logo" />
      </v-layout>
      <v-list>
        <template v-for="link in links">
          <v-list-group v-if="link.children" :key="link.text">
            <template v-slot:activator>
              <v-list-tile>
                <v-list-tile-avatar>
                  <Icon :name="link.icon" />
                </v-list-tile-avatar>
                <v-list-tile-title>{{ link.text }}</v-list-tile-title>
              </v-list-tile>
            </template>
            <v-list-tile
              v-for="child in link.children"
              :key="child.text"
              :to="child.route"
              class="pl-2"
            >
              <v-list-tile-avatar>
                <Icon :name="child.icon" />
              </v-list-tile-avatar>
              <v-list-tile-title>{{ child.text }}</v-list-tile-title>
            </v-list-tile>
          </v-list-group>

          <v-list-tile v-else :to="link.route" :key="link.text">
            <v-list-tile-avatar>
              <Icon :name="link.icon" />
            </v-list-tile-avatar>
            <v-list-tile-title>{{ link.text }}</v-list-tile-title>
          </v-list-tile>
        </template>

        <v-list-tile to="/docs" class="">
          <v-list-tile-avatar>
            <Icon name="reading" />
          </v-list-tile-avatar>
          <v-list-tile-content> Tutoriais </v-list-tile-content>
        </v-list-tile>
      </v-list>
    </v-navigation-drawer>
  </nav>
</template>

<script>
// import LanguageSelector from '@/components/LanguageSelector'
import Toolbar from './Toolbar.vue'
import Icon from '@/components/icons/Icons.vue'

import { mapGetters, mapActions } from 'vuex'
import cms from '@/content'
export default {
  components: {
    // LanguageSelector
    Toolbar,
    Icon
  },
  data() {
    return {
      drawer: true,
      snackbar: false
    }
  },
  computed: {
    ...mapGetters(['authenticated', 'user', 'profile', 'username', 'picture']),
    userDisplayName() {
      return this.$store.getters.userDisplayName
    },
    specialty() {
      return cms.getSpecialtyById(this.user.specialty, this.$i18n.locale)
    },
    userNameCrisp() {
      const user = this.user ? this.user.name + ',' + this.specialty : ''
      return user
    },

    logbookLabel() {
      const specialtyLabels = {
        anesthesiology: 'Anestesiologia',
        'general-surgery': 'Cirurgia Geral'
      }
      return (
        specialtyLabels[this.$store.getters.specialty] ||
        this.$t('common.Logbook')
      )
    },
    links() {
      let links = [
        { icon: 'dashboard', text: this.$t('common.Dashboard'), route: '/' },
        {
          icon: 'curriculum',
          text: 'Currículo',
          children: [
            {
              icon: 'clipboard',
              text: this.logbookLabel,
              route: '/logbook'
            },
            {
              icon: 'cientific',
              text: this.$t('common.ScientificActivity'),
              route: '/curriculum'
            },
            {
              icon: 'certific',
              text: this.$tc('common.Course', 1),
              route: '/course'
            },
            {
              icon: 'activity-plus',
              text: 'Outras actividades',
              route: '/other-activities'
            }
          ]
        },
        {
          icon: 'stats',
          text: 'Estatísticas',
          route: '/stats'
        }
      ]

      if (
        this.user &&
        (this.user.roles || []).some(r =>
          ['internship-responsible', 'coordinator'].includes(r)
        )
      ) {
        links.push({
          icon: 'office',
          text: 'Locais de trabalho',
          route: '/workplaces'
        })
      } else {
        links.push({
          icon: 'internship',
          text: this.$t('common.Internships'),
          route: '/internships'
        })
      }

      if (
        this.user &&
        [
          'orthopedics',
          'general-surgery',
          'neuroradiology',
          'anesthesiology',
          'endocrinology',
          'intensive-medicine',
          'nephrology'
        ].includes(this.user.specialty)
      ) {
        links.push({
          icon: 'partners',
          text: 'Ver Parceiros',
          route: '/Partners'
        })
      }

      if (
        this.user &&
        ['nephrology', 'pathology'].includes(this.user.specialty)
      ) {
        links.push({
          icon: 'learn',
          text: 'Xerpa Learn',
          route: '/XerpaLearn'
        })
      }

      if (
        this.user &&
        (this.user.roles || []).some(r =>
          ['trainee-tutor', 'internship-responsible', 'coordinator'].includes(r)
        )
      ) {
        links.push({
          icon: 'home-user',
          id: 'tutors',
          text: this.$t('common.CoordinatedUsers'),
          children: [
            {
              icon: 'clipboard',
              text: 'Ver ' + this.$t('common.CoordinatedUsers'),
              route: '/internsList'
            },
            {
              icon: 'learn',
              text: 'Registos',
              route: '/coordination'
            }
          ]
        })
      }
      if (
        this.user &&
        (this.user.roles || []).some(r =>
          ['trainee-tutor', 'internship-responsible'].includes(r)
        )
      ) {
        links[links.findIndex(link => link.id === 'tutors')].children.push({
          icon: 'stats',
          text: this.$t('common.InternStat'),
          route: '/internstats'
        })
      }

      if (this.user && (this.user.roles || []).includes('national-admin')) {
        links = [
          { icon: 'dashboard', text: this.$t('common.Dashboard'), route: '/' },
          {
            icon: 'fas fa-calendar-alt',
            text: this.$t('common.Calendar'),
            route: '/calendar'
          },
          {
            icon: 'fas fa-users',
            text: this.$t('common.Contacts'),
            route: '/contacts'
          }
        ]
      }

      return links
    }
  },
  methods: {
    ...mapActions(['login']),
    close() {
      this.$crisp.push(['do', 'session:reset'])
      this.logout()
    },
    disableCrisp(link) {
      if (this.$route.name === 'Dashboard') {
        this.$crisp.push(['do', 'chat:show'])
      } else {
        this.$crisp.push(['do', 'chat:hide'])
      }
    }
  },

  watch: {
    userNameCrisp() {
      this.$crisp.push(['set', 'user:nickname', this.userNameCrisp])
    },
    $route() {
      if (this.$route.name === 'Dashboard') {
        this.$crisp.push(['do', 'chat:show'])
      } else {
        this.$crisp.push(['do', 'chat:hide'])
      }
    }
  }
}
</script>

<style>
.v-list__tile--active {
  background-color: #4eba6f20 !important;
}
</style>
